/* eslint-disable import/no-anonymous-default-export */
import { AxiosWrapper } from "utils/axios.helper";
import { HandleError } from "./errorHandler.service";

const GetSalesData = (filters?: any) => {
    return AxiosWrapper({
        url: "/sales",
        method: "get",
        params: filters
    }).catch((error) => {
        return HandleError(error);
    });
}

const GetSalesSummaryData = (filters?: any) => {
    return AxiosWrapper({
        url: "/sales/summary",
        method: "get",
        params: filters
    }).catch((error) => {
        return HandleError(error);
    });
}

export {
    GetSalesData,
    GetSalesSummaryData
};